import { render } from "./Menu.vue?vue&type=template&id=83e67d5a&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=83e67d5a&lang=scss&scoped=true"
import "./Menu.vue?vue&type=style&index=1&id=83e67d5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83e67d5a"

export default script